"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HourlyForecast = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const react_uid_1 = require("react-uid");
const helpers_1 = require("../../../common/helpers/helpers");
const withStore_1 = __importDefault(require("../../../common/decorators/withStore"));
const WeatherIcon_1 = __importDefault(require("./WeatherIcon"));
const ForecastList = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;

  @media (orientation: landscape) {
    flex-basis: 55%;
    display: flex;
    align-items: center;
    justify-self: right;
  }
`;
const ForecastListItem = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
  padding: 2% 0;

  @media (orientation: landscape) {
    flex-direction: column;
  }
`;
const Time = styled_components_1.default.div `
  flex-basis: 30%;
  font-size: 3vmin;
  font-weight: 200;
`;
const IconWrapper = styled_components_1.default.div `
  flex-basis: 30%;
  position: relative;
  text-align: center;

  @media (orientation: landscape) {
    display: flex;
    align-items: center;
  }

  .weather-icon {
    display: block;
    height: 3.5vh;
    margin: 0 auto;

    @media (orientation: landscape) {
      height: 6.8vh;
    }

    svg {
      height: 100%;
      width: 100%;
    }
  }
`;
const Temperature = styled_components_1.default.div `
  flex-basis: 30%;
  text-align: right;
  font-size: 3vmin;
  font-weight: 200;

  @media (orientation: landscape) {
    display: flex;
    align-items: flex-end;
  }
`;
const Precipitation = styled_components_1.default.span `
  font-size: 3vmin;
  font-weight: 200;
  color: ${(props) => props.theme.palette.mainAppColor.contrastText};
`;
const HourlyForecast = (props) => {
    const timeNow = helpers_1.Helpers.getDateFromStringDependingLocale(new Date().toISOString(), props.currentLocale, props.timezone).time;
    const renderForecast = () => 
    // eslint-disable-next-line consistent-return, array-callback-return
    props.forecast.map((date, index) => {
        const forecastTime = helpers_1.Helpers.getDateFromStringDependingLocale(date.time, props.currentLocale, props.timezone).time;
        if (index === 0) {
            if (parseInt(helpers_1.Helpers.getDateFromStringDependingLocale(date.time, props.currentLocale, props.timezone).time, 10) -
                parseInt(timeNow, 10) <
                0) {
                return "";
            }
        }
        if (index < 5) {
            return (react_1.default.createElement(ForecastListItem, { key: (0, react_uid_1.uid)(date) },
                react_1.default.createElement(Time, null,
                    " ",
                    forecastTime,
                    " "),
                date.symbol === "rain" ||
                    date.symbol === "snow" ||
                    (date.symbol === "sleet" && (react_1.default.createElement(Precipitation, null, `${Math.floor(date.precipProbability)}%`))),
                react_1.default.createElement(IconWrapper, null,
                    react_1.default.createElement(WeatherIcon_1.default, { symbol: date.symbol, whiteTransparentVariant: true })),
                react_1.default.createElement(Temperature, null,
                    date.temperature,
                    "\u00B0")));
        }
    });
    return (react_1.default.createElement(ForecastList, { asSlide: props.asSlide }, renderForecast()));
};
exports.HourlyForecast = HourlyForecast;
const mapStoreToProps = (store) => ({
    timezone: store.getValue("timezone"),
    currentLocale: store.getValue("currentLocale"),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(exports.HourlyForecast);
